import { Component, Inject, OnInit } from '@angular/core';
import { DwComponent, DwComponentType, DwLookupInfo, DwMetaDataService, DwMetaDataServiceToken, DwUserInviteRequestManagerService, DwSecurityUserRegistration, DwUserRegistrationExtensionBase, getParameterByName, sortArrayByField, DwUserInviteRequestPayload } from '@devwareapps/devware-cap';
import { PilexosUserType, PilexosUserTypeIds, convertUserType } from '../../../shared/models/pilexos-user-type.enum';
import { Router } from '@angular/router';
import { PilexosHomePageRepository } from '../../services/pilexos-home-page-repository.service';
import { DwUserTypePilexosEntity } from '../../../../meta-data/extensions/dw-user-type-entity.model';
import { ExaminerRepositoryService } from '../../../examiner/services/examiner-repository.service';
import { AppMetaDataLookups, FlightSchoolOrganizationEntity, UserTypeAllItems } from '../../../../meta-data/app-meta-data.service';

@DwComponent({
  key: 'pilexos-user-registration-extension',
  name: 'Pilexos User Registration Component',
  isGlobal: false,
  componentType: DwComponentType.pageComponent
})
@Component({
  selector: 'app-user-registration',
  templateUrl: './user-registration.component.html',
  styleUrls: ['./user-registration.component.scss']
})
export class UserRegistrationComponent extends DwUserRegistrationExtensionBase {
  userType: PilexosUserTypeIds;
  userTypes: DwUserTypePilexosEntity[];
  dmsNumber: string;
  flightSchoolId: number;
  flightSchoolNameOther: string;

  pilotExaminerUserType = PilexosUserTypeIds.pilotExaminer;
  pilotSchoolUserType = PilexosUserTypeIds.flightSchool;

  readonly OtherFlightSchoolId = 1;

  flightSchoolLookupId = AppMetaDataLookups.FlightSchoolNoneRemoved;
  
  currentFlightSchoolOrganization: FlightSchoolOrganizationEntity;
  lastFlightSchoolId: number;
  validating: boolean;
  schoolIsValid: boolean;
  schoolValiationErrorMessage = 'Flight School has already been claimed, please contact the school administrator to be added as a user.';
  inviteRequest: DwUserInviteRequestPayload;

  constructor(private router: Router,
    private homePageRepository: PilexosHomePageRepository,
    private examinerRepositoryService: ExaminerRepositoryService,
    @Inject(DwMetaDataServiceToken) private dwMetaDataService: DwMetaDataService,
    private dwUserInviteRequestManagerService: DwUserInviteRequestManagerService
  ) {
    super();
  }

  setupComponent() {
    const userTypeMeaning = getParameterByName(this.router, 'type');

    this.inviteRequest = this.dwUserInviteRequestManagerService.getInviteRequestPayload();

    if (!isNaN(parseInt(userTypeMeaning))) {
      this.userType = parseInt(userTypeMeaning);
    } else {
      this.userType = convertUserType(userTypeMeaning);
    }

    if (this.inviteRequest?.userTypeId) {
      this.userType = this.inviteRequest.userTypeId;
    }

    if (!this.userType) {
      this.userType = PilexosUserTypeIds.studentApplicant;
    }

    this.updateUserType();

    this.homePageRepository.getUserTypes()
      .subscribe(userTypes => {
        this.userTypes = sortArrayByField(userTypes.filter(ut => ut.ShowOnRegistration && ut.UserTypeId != UserTypeAllItems.FlightSchool), 'UserTypeOrder');
      });
  }

  customValalidation(userRegistration: DwSecurityUserRegistration, error: string[]) {
    if (this.inviteRequest) {
      return true;
    }

    if (!this.userType) {
      error.push('User type is required');
    }

    if (this.userType == PilexosUserTypeIds.pilotExaminer && !this.dmsNumber) {
      error.push('DMS number is required');
    }

    if (this.userType == PilexosUserTypeIds.flightSchool) {
      if (!this.flightSchoolId) {
        error.push('Flight School is required');
        return;
      }

      if (this.flightSchoolId == this.OtherFlightSchoolId && !this.flightSchoolNameOther) {
        error.push('Flight School Name is required');
      }

      if (this.validating) {
        error.push('Flight School is being validated, please wait a moment and try again');
      } else {
        if (!this.schoolIsValid) {
          error.push(this.schoolValiationErrorMessage);
        }
      }
    }
  }

  updateUserType() {
    // this.data.additionalUserFields[0] = {
    //   FieldName: 'UserTypeId',
    //   FieldValue: this.userType.toString()
    // };
    //this.usert

    const preferredPilotExaminer = this.examinerRepositoryService.getReferredExaminer();

    this.data.additionalData[0] = {
      DataKey: 'ReferredPilotExaminerId',
      DataValue: preferredPilotExaminer?.PilotExaminerId?.toString()
    };

    this.dataChange.emit(this.data);

    this.userRegistrationDataChange.emit({ UserTypeId: this.userType});
  }

  updateDMS() {
    this.data.additionalData[0] = {
      DataKey: 'AuthorityExaminerNumber',
      DataValue: this.dmsNumber
    };

    this.dataChange.emit(this.data);
  }

  updateFlightSchool() {
    this.data.additionalData[1] = {
      DataKey: 'FlightSchoolId',
      DataValue: `${this.flightSchoolId}`
    };
    this.data.additionalData[2] = {
      DataKey: 'FlightSchoolNameOther',
      DataValue: this.flightSchoolNameOther
    };

    if (this.flightSchoolId) {
      if (this.lastFlightSchoolId != this.flightSchoolId) {
        this.lastFlightSchoolId = this.flightSchoolId;
        this.validating = true;
        this.homePageRepository.getFlightSchoolOrganization(this.flightSchoolId)
          .subscribe(flightSchoolOrganization => {
            this.validating = false;
            this.schoolIsValid = !flightSchoolOrganization;
            this.currentFlightSchoolOrganization = flightSchoolOrganization;
          });
      }
    }

    this.dataChange.emit(this.data);
  }

}
